<template>
  <div class="sm-group-forwarding__deliv-addr
              sm-group-forwarding__bottom-gap
              sm-group-forwarding__bottom-gap--line"
  >
    <div class="sm-group-forwarding__deliv-addr--from 
                sm-style-flex"
    >
      <h5 class="sm-group-forwarding__title">From</h5>
      <p class="sm-deliv-addr-descr">
        <span class="sm-txt-capitalize">{{provider.name}}</span>
        <span>{{provider.street}},</span>
        <span>
          <template v-if="provider.city">{{provider.city}}, </template>
          <template v-if="state">{{state.code}} </template>
          <template v-if="provider.zip_code">{{provider.zip_code}}, </template>
          <template v-if="country">{{country.name}}</template>
        </span>
      </p>
    </div>

    <div class="sm-group-forwarding__deliv-addr--to 
                sm-style-flex"
    >
      <h5 class="sm-group-forwarding__title">To</h5>

      <div class="sm-group-forwarding__deliv-addr--to-main">
        <template v-if="Object.keys(curFwAddress).length">
          <div>
            <p 
              v-if="curFwAddress.care_of_name"
              class="sm-txt-strong"
            >C/O: {{curFwAddress.care_of_name}}</p>
            <p 
              v-else-if="curFwAddress.attention"
              class="sm-txt-strong"
            >ATTN: {{curFwAddress.attention}}</p>

            <p
              v-else
              class="sm-txt-strong"
            >{{curPMB.name}}</p>

            <a
              href="#"
              class="sm-link"
              @click.prevent="$emit('open', 'form-edit')"
            >
              <include-svg :name="'icon-edit'" />
              <span>Edit</span>
            </a>
            <template v-if="multipleAddresses">
              <span>or</span>
              <a
                href="#"
                class="sm-link"
                @click.prevent="$emit('show-selected')"
              >
                <include-svg :name="'icon-switch'" />
                <span>Change</span>
              </a>
            </template>
          </div>

          <p class="sm-deliv-addr-descr">
            <span>{{curFwAddress.street}},</span>
            <span>
              <template>{{curFwAddress.city}}, </template>
              <template v-if="curFwAddress.state">{{curFwAddress.state.code}} </template>
              <template>{{curFwAddress.zip_code}}, </template>
              <template v-if="curFwAddress.country">{{curFwAddress.country.name}}</template>
            </span>
            <span v-if="curFwAddress.phone">Tel: {{ curFwAddress.phone }}</span>
          </p>
        </template>
        <div v-else>
          <a
            class="sm-link"
            :class="{
              'disabled': noForm
            }"
            @click.prevent="$emit('open', 'form-create')"
          >
            <include-svg :name="'icon-plus'" />
            <span>Create forward address</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'mailforwarding-addresses',
  props: {
    curFwAddress: {
      type: Object,
      required: true
    },
    curPMB: {
      type: Object,
      required: true
    },
    multipleAddresses: {
      type: Boolean,
      required: true
    },
    noForm: {
      type: Boolean,
      default: false
    },
    country: {
      required: true
    }
  },
  computed: {
    ...mapGetters({
      provider: 'provider',
      countryList: 'countryList'
    }),
    state() {
      if (this.provider.state_id && this.country && this.country.states && this.country.states) {
        return this.country.states.find(state => state.id == this.provider.state_id);
      }

      return null;
    },
  }
}
</script>